import React, { useState } from 'react'
import { currency } from './inventoryData';

function SupplierManagementPage({ suppliers }) {
    const [query, setQuery] = useState('');
    const rows = suppliers.filter(item => item.name.toLowerCase().includes(query.toLowerCase()) || item.contact.includes(query));

    return (
        <section className='inventory-panel inventory-table-panel full'>
            <div className='inventory-toolbar'>
                <span>Supplier Management</span>
                <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder='Search supplier...' />
            </div>
            <div className='inventory-card-grid'>
                {rows.map(item => (
                    <article className='inventory-supplier-card' key={item.id}>
                        <h3>{item.name}</h3>
                        <p>Contact: {item.contact}</p>
                        <p>Pending Amount: {currency.format(item.pending)}</p>
                        <p>Last Order Date: {item.lastOrder}</p>
                        <div className='inventory-row-actions'>
                            <button>Call</button>
                            <button>History</button>
                            <button>Add Supplier</button>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}

export default SupplierManagementPage
